import React from 'react'
import GetionCases from './pages/gestionCases'
import Home from './pages'
import EditImplicatedCases from './containers/componentCaseHistory/form/FormImplicatedCases'
import AsignatedResponsable from './pages/asignatedResponsable'
import RecordLiquidation from './pages/recordLiquidation'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import { EncargadoCompaniaComponent } from 'recupero-area-trabajo'

const RouterAPP = () => (
  <BrowserRouter>
    <Routes>
      <Route index path='/' element={<Home />} />
      <Route index path='/recepcionar-caso' element={<GetionCases />} />
      <Route index path='/asignar-responsable' element={<AsignatedResponsable />}/>
      <Route path='/editar-implicado-tercero' element={<EditImplicatedCases />} />
      <Route path='/area-trabajo' element={<EncargadoCompaniaComponent />} />
      <Route path='/antecedentes-liquidacion' element={<RecordLiquidation />} />
    </Routes>
  </BrowserRouter>
)

export default RouterAPP
